import Request from './request';

export default class Comment extends Request {

    add( issus_id, content ) {
        return `mutation {
            addComment(input: {subjectId: "${ issus_id }", body: "${ content }"}) {
                commentEdge {
                    node {
                        id
                        body
                        author {
                            login
                        }
                    }
                }
            }
        }`;
    }
}